import React from "react";
import styled from "@emotion/styled";
import { DialogModal } from "../../DialogModal";
import { Button } from "../../Button";

type Props = {
  close: () => void;
  confirm: () => void;
  isBusiness?: boolean;
  isLoading: boolean;
  isVisible: boolean;
  newTotal?: string;
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

export const PlanChangeConfirmModal = ({
  close,
  confirm,
  isBusiness,
  isLoading,
  isVisible,
  newTotal,
}: Props) => (
  <DialogModal
    onClose={close}
    isOpen={isVisible}
    title={
      isBusiness
        ? "We'll update your Climate Action Workforce"
        : "Are you sure?"
    }
  >
    {isBusiness ? (
      <p>
        Your new monthly payment amount will be <strong>{newTotal}</strong>.
        Payments will be made via your existing saved payment method in Account
        &gt; Billing. Do you wish to continue?
      </p>
    ) : (
      <p>
        Your subscription will be updated for your next charge. Your existing
        trees and carbon avoidance will not be affected.
      </p>
    )}
    <ButtonWrapper>
      <Button
        disabled={isLoading}
        loading={isLoading}
        primary
        onClick={confirm}
        text="Confirm update"
      />
      <Button
        disabled={isLoading}
        textOnlyWithBorder
        onClick={close}
        text="Cancel"
      />
    </ButtonWrapper>
  </DialogModal>
);
